import React, { useState, useEffect, useCallback } from 'react';
import { db, auth } from '../../firebase/firebase';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import WIcon from '../../components/shared/WIcon';

const formatDateTime = (value) => {
  if (!value) return '—';
  const d = value.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

const VendorRedemptions = () => {
  const [redemptions, setRedemptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const fetchRedemptions = useCallback(async () => {
    if (!auth.currentUser) return;
    try {
      const snap = await getDocs(
        query(
          collection(db, 'redemptions'),
          where('vendorId', '==', auth.currentUser.uid),
          orderBy('redeemedAt', 'desc'),
        )
      );
      setRedemptions(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error('Error fetching redemptions:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchRedemptions(); }, [fetchRedemptions]);

  const filtered = redemptions.filter((r) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return [r.userName, r.offerTitle, r.vendorStaffName, r.userCompanyName]
      .filter(Boolean)
      .some((field) => field.toLowerCase().includes(q));
  });

  return (
    <div className="loysta-card">
      <div style={{ padding: '14px 20px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, background: '#f8fafc', border: '1.5px solid #e2e8f0', borderRadius: 7, padding: '7px 12px' }}>
          <WIcon name="search" size={15} color="#94a3b8" />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search by employee, offer, staff…"
            style={{ border: 'none', background: 'none', fontSize: 13, fontFamily: 'inherit', color: '#0f172a', outline: 'none', width: '100%' }}
          />
        </div>
        <span style={{ fontSize: 13, color: '#94a3b8' }}>
          {filtered.length} {filtered.length === 1 ? 'redemption' : 'redemptions'}
        </span>
        <button
          type="button"
          onClick={fetchRedemptions}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '8px 14px', background: '#0f172a', color: 'white',
            border: 'none', borderRadius: 8,
            fontSize: 13, fontWeight: 700, fontFamily: 'inherit',
            cursor: 'pointer', whiteSpace: 'nowrap',
          }}
        >
          Refresh
        </button>
      </div>

      <table className="loysta-table">
        <thead>
          <tr>
            <th>When</th>
            <th>Employee</th>
            <th>Company</th>
            <th>Offer</th>
            <th>Discount</th>
            <th>Scanned by</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan="6" style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>Loading redemptions…</td></tr>
          ) : filtered.length === 0 ? (
            <tr><td colSpan="6" style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>
              {redemptions.length === 0
                ? 'No redemptions yet. Once your staff scan a QR in the Loysta Vendor app, activity will appear here.'
                : 'No redemptions match your search.'}
            </td></tr>
          ) : filtered.map((r) => (
            <tr key={r.id}>
              <td style={{ color: '#64748b', fontSize: 12, whiteSpace: 'nowrap' }}>
                {formatDateTime(r.redeemedAt)}
              </td>
              <td>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>{r.userName || 'Unknown'}</div>
                {r.userTier && (
                  <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>Tier {r.userTier}</div>
                )}
              </td>
              <td style={{ fontSize: 13, color: '#475569' }}>
                {r.userCompanyName || '—'}
              </td>
              <td style={{ fontSize: 13, color: '#0f172a' }}>{r.offerTitle || '—'}</td>
              <td>
                {r.discountPercent != null ? (
                  <span style={{ background: '#fef3c7', color: '#92400e', padding: '3px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700 }}>
                    {r.discountPercent}%
                  </span>
                ) : '—'}
              </td>
              <td style={{ fontSize: 13, color: '#475569' }}>{r.vendorStaffName || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VendorRedemptions;
